(function () {
  var STORAGE_KEY = (window.wishlistConfig && window.wishlistConfig.storageKey) || 'ratniva-wishlist';
  var CARD_CACHE_VERSION = 3;
  var GUEST_STORAGE_KEY = STORAGE_KEY + ':guest';
  var CUSTOMER_STORAGE_PREFIX = STORAGE_KEY + ':customer:';
  var LEGACY_STORAGE_KEYS = [STORAGE_KEY];

  function getCurrentCustomerId() {
    if (window.wishlistConfig && window.wishlistConfig.customerId) {
      return String(window.wishlistConfig.customerId);
    }

    return '';
  }

  function getGuestStorageKey() {
    return GUEST_STORAGE_KEY;
  }

  function getCustomerStorageKey(customerId) {
    return CUSTOMER_STORAGE_PREFIX + String(customerId);
  }

  function getActiveStorageKey() {
    var customerId = getCurrentCustomerId();
    return customerId ? getCustomerStorageKey(customerId) : getGuestStorageKey();
  }

  function isWishlistStorageKey(key) {
    if (!key) {
      return false;
    }

    return key === STORAGE_KEY || key === GUEST_STORAGE_KEY || key.indexOf(CUSTOMER_STORAGE_PREFIX) === 0;
  }

  function readWishlistFromKey(key) {
    try {
      var parsed = JSON.parse(localStorage.getItem(key));
      return Object.prototype.toString.call(parsed) === '[object Object]' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeWishlistToKey(key, items) {
    try {
      localStorage.setItem(key, JSON.stringify(items));
      return true;
    } catch (error) {
      console.error('Wishlist storage failed.', error);
      return false;
    }
  }

  function removeWishlistKey(key) {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('Wishlist storage cleanup failed.', error);
      return false;
    }
  }

  function readWishlist() {
    return readWishlistFromKey(getActiveStorageKey());
  }

  function writeWishlist(items) {
    return writeWishlistToKey(getActiveStorageKey(), items);
  }

  function mergeWishlistRecord(existingRecord, incomingRecord) {
    var existing = existingRecord || {};
    var incoming = incomingRecord || {};
    var existingAddedAt = existing.addedAt || 0;
    var incomingAddedAt = incoming.addedAt || 0;
    var primary = incomingAddedAt > existingAddedAt ? incoming : existing;
    var fallback = primary === incoming ? existing : incoming;

    return {
      productId: primary.productId || fallback.productId || '',
      handle: primary.handle || fallback.handle || '',
      variantId: primary.variantId || fallback.variantId || '',
      productUrl: primary.productUrl || fallback.productUrl || '',
      productTitle: primary.productTitle || fallback.productTitle || '',
      addedAt: Math.max(existingAddedAt, incomingAddedAt),
      available: typeof primary.available === 'boolean' ? primary.available : fallback.available,
      cardCacheVersion: primary.cardHtml
        ? primary.cardCacheVersion || CARD_CACHE_VERSION
        : fallback.cardCacheVersion || CARD_CACHE_VERSION,
      cardHtml: primary.cardHtml || fallback.cardHtml || '',
    };
  }

  function mergeWishlistCollections(baseItems, incomingItems) {
    var merged = Object.assign({}, baseItems || {});

    Object.keys(incomingItems || {}).forEach(function (productId) {
      if (merged[productId]) {
        merged[productId] = mergeWishlistRecord(merged[productId], incomingItems[productId]);
      } else {
        merged[productId] = incomingItems[productId];
      }
    });

    return merged;
  }

  function syncWishlistStorage() {
    var activeKey = getActiveStorageKey();
    var activeItems = readWishlistFromKey(activeKey);
    var sourceKeysToClear = [];
    var hasChanges = false;

    LEGACY_STORAGE_KEYS.forEach(function (legacyKey) {
      if (legacyKey === activeKey) {
        return;
      }

      var legacyItems = readWishlistFromKey(legacyKey);
      if (!Object.keys(legacyItems).length) {
        return;
      }

      activeItems = mergeWishlistCollections(activeItems, legacyItems);
      sourceKeysToClear.push(legacyKey);
      hasChanges = true;
    });

    if (getCurrentCustomerId()) {
      var guestKey = getGuestStorageKey();
      if (guestKey !== activeKey) {
        var guestItems = readWishlistFromKey(guestKey);
        if (Object.keys(guestItems).length) {
          activeItems = mergeWishlistCollections(activeItems, guestItems);
          sourceKeysToClear.push(guestKey);
          hasChanges = true;
        }
      }
    }

    if (!hasChanges) {
      return false;
    }

    if (!writeWishlistToKey(activeKey, activeItems)) {
      return false;
    }

    sourceKeysToClear.forEach(function (key) {
      removeWishlistKey(key);
    });

    return true;
  }

  function getWishlistItems() {
    var items = readWishlist();
    return Object.keys(items).reduce(function (accumulator, key) {
      var item = items[key];
      if (item && item.productId && item.handle) {
        accumulator[key] = item;
      }
      return accumulator;
    }, {});
  }

  function getWishlistArray() {
    return Object.values(getWishlistItems()).sort(function (left, right) {
      return (right.addedAt || 0) - (left.addedAt || 0);
    });
  }

  function emitWishlistUpdated() {
    var detail = {
      count: getWishlistArray().length,
      items: getWishlistArray(),
    };

    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: detail,
      })
    );
  }

  function getWishlistUrl() {
    if (window.wishlistConfig && window.wishlistConfig.pageUrl) {
      return window.wishlistConfig.pageUrl;
    }

    var link = document.querySelector('[data-wishlist-link]');
    return link ? link.getAttribute('href') : '#';
  }

  function buildWishlistViewUrl(handle) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }

    root = root.replace(/\/$/, '');
    return root + '/products/' + encodeURIComponent(handle) + '?view=wishlist-card';
  }

  function getMoveToCartDefaultLabel() {
    return 'Move to cart';
  }

  function getSoldOutLabel() {
    return (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
  }

  function resolveVariantId(cardWrapper, fallbackVariantId) {
    if (fallbackVariantId) {
      return fallbackVariantId;
    }

    if (!cardWrapper) {
      return '';
    }

    var existingMoveToCart = cardWrapper.querySelector('[data-wishlist-move-to-cart]');
    if (existingMoveToCart && existingMoveToCart.dataset.variantId) {
      return existingMoveToCart.dataset.variantId;
    }

    var variantInput = cardWrapper.querySelector('[name="id"]');
    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    return '';
  }

  function resolveAvailability(cardWrapper, fallbackAvailability) {
    if (typeof fallbackAvailability === 'boolean') {
      return fallbackAvailability;
    }

    if (!cardWrapper) {
      return true;
    }

    var variantInput = cardWrapper.querySelector('[name="id"]');
    if (variantInput) {
      return !variantInput.disabled;
    }

    var disabledQuickAdd = cardWrapper.querySelector('.quick-add__submit[disabled]');
    return !disabledQuickAdd;
  }

  function buildMoveToCartButton(cardWrapper, item) {
    // Older cached cards have no option metadata: require product-page selection.
    if (cardWrapper.dataset.wishlistRequiresOptions !== 'false') {
      var optionsContainer = document.createElement('div');
      var optionsLink = document.createElement('a');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      optionsContainer.className = 'quick-add no-js-hidden';
      optionsLink.className = 'quick-add__submit button button--full-width button--secondary';
      optionsLink.href = root.replace(/\/$/, '') + '/products/' + encodeURIComponent(item.handle);
      if (item.variantId) {
        optionsLink.href += '?variant=' + encodeURIComponent(item.variantId);
      }
      optionsLink.textContent = cardWrapper.dataset.wishlistChooseOptionsLabel || 'Choose options';
      optionsContainer.appendChild(optionsLink);
      return optionsContainer;
    }

    var variantId = resolveVariantId(cardWrapper, item.variantId);
    var isAvailable = resolveAvailability(cardWrapper, item.available) && Boolean(variantId);
    var quickAdd = document.createElement('div');
    var button = document.createElement('button');
    var label = document.createElement('span');

    quickAdd.className = 'quick-add no-js-hidden';

    button.type = 'button';
    button.className = 'quick-add__submit button button--full-width button--secondary';
    button.dataset.wishlistMoveToCart = '';
    button.dataset.productId = item.productId || '';
    button.dataset.variantId = variantId;
    button.dataset.defaultLabel = getMoveToCartDefaultLabel();
    button.dataset.loadingLabel = 'Moving...';

    if (!isAvailable) {
      button.disabled = true;
    }

    label.setAttribute('data-wishlist-action-label', '');
    label.textContent = isAvailable ? getMoveToCartDefaultLabel() : getSoldOutLabel();

    button.appendChild(label);
    quickAdd.appendChild(button);

    return quickAdd;
  }

  function normaliseWishlistCardHtml(html, item) {
    if (!html) {
      return '';
    }

    var template = document.createElement('template');
    template.innerHTML = html.trim();

    var cardWrapper = template.content.querySelector('.card-wrapper');
    if (!cardWrapper) {
      return '';
    }

    // The saved wishlist record can be older than the current product inventory.
    // Use the freshly rendered Shopify card as the availability source.
    var currentItem = Object.assign({}, item, {
      variantId: resolveVariantId(cardWrapper, item.variantId),
      available: resolveAvailability(cardWrapper, undefined),
    });

    cardWrapper.setAttribute('data-wishlist-card', '');

    if (currentItem.productId) {
      cardWrapper.dataset.productId = currentItem.productId;
    }

    if (currentItem.handle) {
      cardWrapper.dataset.productHandle = currentItem.handle;
    }

    var wishlistToggle = cardWrapper.querySelector('[data-wishlist-toggle]');
    if (wishlistToggle) {
      wishlistToggle.dataset.productId = currentItem.productId || wishlistToggle.dataset.productId || '';
      wishlistToggle.dataset.productHandle = currentItem.handle || wishlistToggle.dataset.productHandle || '';
      wishlistToggle.dataset.productTitle = currentItem.productTitle || wishlistToggle.dataset.productTitle || '';
      wishlistToggle.dataset.variantId = currentItem.variantId;
    }

    var cardContent = cardWrapper.querySelector('.card > .card__content:last-child');
    var cardInformation = cardContent ? cardContent.querySelector('.card__information') : null;
    var cardBadge = cardContent ? cardContent.querySelector('.card__badge') : null;

    if (cardContent && cardInformation && cardBadge) {
      Array.from(cardContent.children).forEach(function (child) {
        if (child !== cardInformation && child !== cardBadge) {
          child.remove();
        }
      });

      cardContent.insertBefore(buildMoveToCartButton(cardWrapper, currentItem), cardBadge);
    } else {
      var existingMoveToCart = cardWrapper.querySelector('[data-wishlist-move-to-cart]');
      if (existingMoveToCart) {
        existingMoveToCart.dataset.productId = currentItem.productId || existingMoveToCart.dataset.productId || '';
        existingMoveToCart.dataset.variantId = currentItem.variantId;
        existingMoveToCart.dataset.defaultLabel = getMoveToCartDefaultLabel();
        existingMoveToCart.dataset.loadingLabel = 'Moving...';
      }
    }

    return cardWrapper.outerHTML;
  }

  function captureWishlistCardHtml(button, record) {
    var cardWrapper = button.closest('.card-wrapper');
    if (!cardWrapper) {
      return '';
    }

    return normaliseWishlistCardHtml(cardWrapper.outerHTML, record);
  }

  function isProductWishlisted(productId) {
    if (!productId) return false;
    return Boolean(getWishlistItems()[productId]);
  }

  function getProductRecord(button) {
    if (!button) return null;

    var productId = button.dataset.productId;
    var handle = button.dataset.productHandle;

    if (!productId || !handle) {
      return null;
    }

    var productInfo = button.closest('product-info');
    var selectedVariantInput = productInfo && productInfo.querySelector('product-form form [name="id"]');
    var record = {
      productId: productId,
      handle: handle,
      variantId: (selectedVariantInput && selectedVariantInput.value) || button.dataset.variantId || '',
      productUrl: button.dataset.productUrl || '',
      productTitle: button.dataset.productTitle || '',
      addedAt: Date.now(),
      available: resolveAvailability(button.closest('.card-wrapper'), undefined),
      cardCacheVersion: CARD_CACHE_VERSION,
    };

    record.cardHtml = captureWishlistCardHtml(button, record);

    return record;
  }

  function updateWishlistCountText(count) {
    document.querySelectorAll('[data-wishlist-count-text]').forEach(function (node) {
      node.textContent = count + ' item' + (count === 1 ? '' : 's');
    });
  }

  function updateHeaderState() {
    var count = getWishlistArray().length;
    var wishlistUrl = getWishlistUrl();

    document.querySelectorAll('[data-wishlist-link]').forEach(function (link) {
      link.setAttribute('href', wishlistUrl);
      link.classList.toggle('is-active', count > 0);
    });

    document.querySelectorAll('[data-wishlist-count-bubble]').forEach(function (bubble) {
      if (count > 0) {
        bubble.hidden = false;
        bubble.innerHTML =
          '<span aria-hidden="true">' +
          (count < 100 ? count : '99+') +
          '</span><span class="visually-hidden">' +
          count +
          ' items in wishlist</span>';
      } else {
        bubble.hidden = true;
        bubble.innerHTML = '';
      }
    });

    updateWishlistCountText(count);
  }

  function updateWishlistToggleState(button) {
    if (!button) return;

    var productId = button.dataset.productId;
    var productTitle = button.dataset.productTitle || 'product';
    var isActive = isProductWishlisted(productId);
    var label = isActive ? 'Remove ' + productTitle + ' from wishlist' : 'Add ' + productTitle + ' to wishlist';
    var hiddenLabel = button.querySelector('[data-wishlist-label]');

    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    button.setAttribute('aria-label', label);

    if (hiddenLabel) {
      hiddenLabel.textContent = isActive ? 'Remove from wishlist' : 'Add to wishlist';
    }
  }

  function updateAllWishlistToggles(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(updateWishlistToggleState);
  }

  function toggleWishlist(button) {
    var record = getProductRecord(button);
    if (!record) return null;

    var items = getWishlistItems();
    var added = !items[record.productId];

    if (added) {
      items[record.productId] = record;
    } else {
      delete items[record.productId];
    }

    if (!writeWishlist(items)) {
      return null;
    }

    emitWishlistUpdated();
    return added;
  }

  function getWishlistGrid() {
    return document.querySelector('[data-wishlist-grid]');
  }

  function getWishlistEmptyState() {
    return document.querySelector('[data-wishlist-empty]');
  }

  function getWishlistHeader() {
    return document.querySelector('[data-wishlist-header]');
  }

  function syncWishlistPageVisibility() {
    var grid = getWishlistGrid();
    if (!grid) return;

    var emptyState = getWishlistEmptyState();
    var header = getWishlistHeader();
    var hasCards = grid.querySelector('[data-wishlist-card]');

    if (header) {
      header.hidden = !hasCards;
    }

    if (emptyState) {
      emptyState.hidden = Boolean(hasCards);
    }

    grid.hidden = !hasCards;
  }

  async function renderWishlistPage() {
    var grid = getWishlistGrid();
    if (!grid) return;

    var emptyState = getWishlistEmptyState();
    var items = getWishlistArray();
    var itemsMap = getWishlistItems();
    var itemsToRefresh = [];

    grid.innerHTML = '';
    grid.hidden = true;

    if (emptyState) {
      emptyState.hidden = true;
    }

    if (!items.length) {
      syncWishlistPageVisibility();
      return;
    }

    items.forEach(function (item) {
      if (item.cardHtml) {
        var listItem = document.createElement('li');
        listItem.className = 'grid__item';
        listItem.innerHTML = normaliseWishlistCardHtml(item.cardHtml, item);
        grid.appendChild(listItem);
      }

      itemsToRefresh.push(item);
    });

    updateAllWishlistToggles(grid);
    syncWishlistPageVisibility();

    if (!itemsToRefresh.length) {
      return;
    }

    var staleProductIds = [];
    var fragments = await Promise.all(
      itemsToRefresh.map(async function (item) {
        try {
          var response = await fetch(buildWishlistViewUrl(item.handle), {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          if (!response.ok) {
            throw new Error('Wishlist card request failed.');
          }

          var html = (await response.text()).trim();
          if (!html) {
            throw new Error('Wishlist card response was empty.');
          }

          var normalisedHtml = normaliseWishlistCardHtml(html, item);
          if (!normalisedHtml) {
            throw new Error('Wishlist card response could not be normalised.');
          }

          if (itemsMap[item.productId]) {
            itemsMap[item.productId].cardHtml = normalisedHtml;
            itemsMap[item.productId].cardCacheVersion = CARD_CACHE_VERSION;
            itemsMap[item.productId].available = resolveAvailability(
              document.createRange().createContextualFragment(normalisedHtml).querySelector('.card-wrapper'),
              undefined
            );
          }

          return { productId: item.productId, html: normalisedHtml };
        } catch (error) {
          if (!item.cardHtml) {
            staleProductIds.push(item.productId);
          }
          return null;
        }
      })
    );

    fragments.forEach(function (fragment) {
      if (!fragment) return;

      var listItem = document.createElement('li');
      listItem.className = 'grid__item';
      listItem.innerHTML = fragment.html;

      var currentCard = Array.from(grid.querySelectorAll('[data-wishlist-card]')).find(function (card) {
        return card.dataset.productId === fragment.productId;
      });
      var currentListItem = currentCard && currentCard.closest('.grid__item');

      if (currentListItem) {
        currentListItem.replaceWith(listItem);
      } else {
        grid.appendChild(listItem);
      }
    });

    if (staleProductIds.length) {
      staleProductIds.forEach(function (productId) {
        delete itemsMap[productId];
      });
    }

    writeWishlist(itemsMap);

    if (staleProductIds.length) {
      emitWishlistUpdated();
    }

    updateAllWishlistToggles(grid);
    syncWishlistPageVisibility();
  }

  function removeWishlistCardElement(button) {
    var gridItem = button.closest('.grid__item');
    if (gridItem) {
      gridItem.remove();
    }
    syncWishlistPageVisibility();
  }

  function setMoveToCartButtonState(button, isLoading) {
    var label = button.querySelector('[data-wishlist-action-label]');
    var spinner = button.querySelector('.loading__spinner');

    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.disabled = isLoading;

    if (label) {
      label.textContent = isLoading ? button.dataset.loadingLabel || 'Moving...' : button.dataset.defaultLabel || 'Move to cart';
    }

    if (spinner) {
      spinner.classList.toggle('hidden', !isLoading);
    }
  }

  async function moveWishlistItemToCart(button) {
    var variantId = button.dataset.variantId;
    var productId = button.dataset.productId;

    if (!variantId || !productId) {
      return;
    }

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    config.body = formData;
    setMoveToCartButtonState(button, true);

    try {
      var response = await fetch(window.routes.cart_add_url, config);
      var parsedState = await response.json();

      if (parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || 'Unable to add this item to cart.');
      }

      var items = getWishlistItems();
      delete items[productId];
      writeWishlist(items);
      emitWishlistUpdated();
      removeWishlistCardElement(button);

      if (!cart) {
        window.location.href = window.routes.cart_url;
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'wishlist',
          productVariantId: variantId,
          cartData: parsedState,
        });
      }

      if (typeof cart.renderContents === 'function') {
        cart.renderContents(parsedState);
      }
    } catch (error) {
      console.error(error);
      setMoveToCartButtonState(button, false);
      window.alert('Unable to move this item to cart right now.');
    }
  }

  function handleDocumentClick(event) {
    var wishlistToggle = event.target.closest('[data-wishlist-toggle]');
    if (wishlistToggle) {
      event.preventDefault();

      var added = toggleWishlist(wishlistToggle);
      if (added === null) {
        return;
      }
      updateAllWishlistToggles(document);

      if (!added && wishlistToggle.closest('[data-wishlist-card]')) {
        removeWishlistCardElement(wishlistToggle);
      }

      return;
    }

    var moveToCartButton = event.target.closest('[data-wishlist-move-to-cart]');
    if (moveToCartButton) {
      event.preventDefault();
      if (!moveToCartButton.disabled) {
        moveWishlistItemToCart(moveToCartButton);
      }
    }
  }

  function initialiseWishlist() {
    syncWishlistStorage();
    updateHeaderState();
    updateAllWishlistToggles(document);
    renderWishlistPage();

    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('wishlist:updated', function () {
      updateHeaderState();
      updateAllWishlistToggles(document);
    });

    window.addEventListener('storage', function (event) {
      if (isWishlistStorageKey(event.key)) {
        syncWishlistStorage();
        updateHeaderState();
        updateAllWishlistToggles(document);
        renderWishlistPage();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseWishlist);
  } else {
    initialiseWishlist();
  }
})();
